import { createContext } from "react";

export const defaultServiceValues = {
  Load:{
    isLoading: 0
  },
  Alerts:[],
  showSettings: false,
  addEvent: false,
  deleteCusRequest: false
}


const ServiceContext = createContext(
  { set: undefined, get: undefined }
);

export default ServiceContext 
